import TrashIcon from "../../components/icons/TrashIcon";
import { useDraggable } from "@dnd-kit/core";
import { CourseOption } from "../../types/course.response";
import { getCourseKey } from "../../utils/courseUtils";
import type { DragSource } from "./CourseCardForDragging";

interface CourseCardInSemesterProps {
    courseOption: CourseOption;
    onDeleteCourse: (course: CourseOption) => void;
}

export default function CourseCardInSemester({ courseOption, onDeleteCourse }: CourseCardInSemesterProps) {
    const courseKey = getCourseKey(courseOption);
    const source: DragSource = 'semester';

    const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
        id: `scheduled-${courseKey}`,
        data: { courseOption, source },
    });

    return (
        <div 
            ref={setNodeRef}
            {...listeners}
            {...attributes}
            className={`flex items-stretch rounded-md shadow-md border border-gray-200 overflow-hidden cursor-grab active:cursor-grabbing hover:shadow-lg transition-all ${
                isDragging ? 'opacity-50' : ''
            }`}
        >
            <div className="flex-shrink-0 bg-gray-100 rounded-l px-1.5 py-2 hover:bg-gray-200 transition-colors flex items-center">
                <div className="grid grid-cols-2 gap-0.5">
                    <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                    <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                    <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                    <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                </div>
            </div>
            
            <div className="flex items-center justify-between gap-2 flex-1 min-w-0 px-3 py-2 bg-white">
                <div className="flex-1 min-w-0">
                    <p className="text-xs text-gray-600 truncate">
                        {courseOption.courseInfo.subject} {courseOption.courseInfo.number}
                    </p>
                    <p className="text-base truncate">
                        {courseOption.courseInfo.titleShort}
                    </p>
                    {courseOption.topic && (
                        <p className="text-xs text-gray-500 truncate">
                            {courseOption.topic}
                        </p>
                    )}
                    <span className="text-xs text-gray-600">
                        {courseOption.userState.creditsReceived} credits
                    </span>
                </div>
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onDeleteCourse(courseOption);
                    }}
                    onPointerDown={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    className="flex-shrink-0 p-1 hover:bg-gray-200 rounded cursor-pointer"
                    aria-label="Remove course from semester"
                >
                    <TrashIcon className="w-4 h-4 text-gray-600" />
                </button>
            </div>
        </div>
    )
}
